import {getAuthenticationEvents} from './events/getAuthenticationEvents.js'
import {getLeadEvents} from './events/getLeadEvents.js'
import {getPhoneViewedEvents} from './events/getPhoneViewedEvents.js'
import {getReservationEvents} from './events/getReservationEvents.js'

export const optimizelyTrackingMiddleware = ({payload, next}) => {
  const {
    obj: {event, properties, integrations}
  } = payload

  if (!window.optimizelyClientInstance) {
    next(payload)
    return
  }

  const optimizelyLeadTriggered = getLeadEvents({
    event,
    properties
  })

  const optimizelyReservationEvents = getReservationEvents({event, properties})
  const optimizelyPhoneViewedEvents = getPhoneViewedEvents({event, properties})
  const optimizelyAuthenticationEvents = getAuthenticationEvents({event})

  const optimizelyEventNames = [
    ...optimizelyLeadTriggered,
    ...optimizelyReservationEvents,
    ...optimizelyPhoneViewedEvents,
    ...optimizelyAuthenticationEvents
  ].filter(Boolean)

  if (optimizelyEventNames && optimizelyEventNames.length > 0) {
    optimizelyEventNames.forEach(event =>
      window.optimizelyClientInstance.track(
        event,
        window.analytics.user().anonymousId(),
        integrations?.Optimizely?.attributes
      )
    )
  }

  next(payload)
}
